import React, {memo, useCallback, useState, useEffect} from 'react';

import Block from '../block';

import HidableBox from '../hidable-box';

import Event from './event';
import style from './event-category.module.scss';
import EventsList from './events-list';

export default memo(
	/**
	 * @param {{
	 *   events: Array<import("../../utils/events").Event>,
	 *   hashOpenedEventId: null | string,
	 *   dataVersion: number,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function EventCategory({events, hashOpenedEventId, dataVersion}) {
		const [open, setOpen] = useState(false);
		const toggleOpen = useCallback(
			() => setOpen((prev) => !prev),
			[],
		);

		useEffect(
			() => {
				setOpen(events.findIndex((e) => e.id === hashOpenedEventId) !== -1);
			},
			[hashOpenedEventId, dataVersion, events],
		);

		return (
			<Block>
				<div className={style.base}>
					<HidableBox
						visible={open}
						toggleVisible={toggleOpen}
						header={(
							<h1 className={style.headerTitle}>{events[0].category}</h1>
						)}
					>
						<EventsList
							visible={open}
							events={events}
							hashOpenedEventId={hashOpenedEventId}
							dataVersion={dataVersion}
						/>
					</HidableBox>
				</div>
			</Block>
		);
	}
);
